<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Division</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="division"
                label="Divisi"
                class="mb-0 required"
                type="text"
                required
                horizontal
                placeholder="Division"
                v-model="data.division_name"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="createDivision">Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import DivisionUseCase from '../app/usecase/division';

export default {
  name: "DivisionCreate",
  data() {
    return {
      data: {
        division_name: "",
      },
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication()
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      if (this.data.division_name) {
        return this.$swal.fire({
          icon: "info",
          title: "Are you sure want to leave?",
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
          showCloseButton: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.usersOpened ? this.$router.go(-1) : this.$router.push({ path: "/career/division" });
          }
        })
      } else {
        this.usersOpened ? this.$router.go(-1) : this.$router.push({ path: "/career/division" });
      }
    },
    async createDivision() {
      let formData = new FormData();
      formData.append("division_name", this.data.division_name);
      const { err } = await DivisionUseCase.saveOne(formData)
      if (err) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err
        })
      }
      else {
        this.$swal.fire({
          icon: "success",
          title: "Division Created",
          showConfirmButton: false,
          timer: 2000,
        })
        this.$router.push({ path: `/career/division` });
      }
    },
  }
};
</script>
